import { Box, type ColorProps, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faBadgeCheck, faDumbbell, faFileCertificate } from '@fortawesome/pro-solid-svg-icons'

import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Icon from '@/components/UI/Icon/Icon'

type WhyGetCertifiedItem = {
  icon: IconDefinition
  iconColor: ColorProps['color']
  title: string
  description: string
  href?: string
}

const WHY_GET_CERTIFIED: WhyGetCertifiedItem[] = [
  {
    icon: faDumbbell,
    iconColor: 'green.fg',
    title: 'Build confidence.',
    description:
      'Have a big test soon? Practice through certifications and gain confidence to tackle anything.',
  },
  {
    icon: faBadgeCheck,
    iconColor: 'blue.fg',
    title: 'Become a tutor.',
    description: 'Get an official certified tutor badge and become eligible to host live sessions.',
    href: url.getBecomeATutorUrl(),
  },
  {
    icon: faFileCertificate,
    iconColor: 'purple.fg',
    title: 'Build a college-ready portfolio.',
    description: 'Send your certifications to colleges like UChicago, Case Western and MIT.',
    href: url.faq.getArticleUrl('what-is-a-portfolio'),
  },
]

export default function WhyGetCertified(): JSX.Element {
  return (
    <Stack direction="column" spacing="24px">
      <Heading size="xl">Why get certified?</Heading>

      <SimpleGrid columns={[1, 1, 3]} spacing="8px">
        {WHY_GET_CERTIFIED.map(({ icon, iconColor, title, description, href }) => (
          <Box key={title} p="16px" borderRadius="8px" bg="bg.subtle">
            <Stack direction="column" spacing="8px">
              <Stack direction="row" align="center">
                <Icon faIcon={icon} color={iconColor} size="lg" omitContainer />
                <Text fontWeight="bold">{title}</Text>
              </Stack>
              <Box>
                {description} {href == null ? null : <ShwLink href={href}>Learn more</ShwLink>}
              </Box>
            </Stack>
          </Box>
        ))}
      </SimpleGrid>
    </Stack>
  )
}
